import { SplitFactory } from '@splitsoftware/splitio';
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import { TOKEN, HELPER } from 'utils';
import packageInfo from '../../package.json';

export const initSplit = callback => {
  const factory = SplitFactory({
    core: {
      authorizationKey: process.env.SPLIT_IO_KEY,
      key: HELPER.getUserId(),
    },
  });

  const client = factory.client();

  client.on(client.Event.SDK_READY, () => {
    callback('ready', client);
  });

  client.on(client.Event.SDK_READY_TIMED_OUT, () => {
    callback('timeout', client);
  });
};

const createAttribute = () => {
  const token = jwt_decode(TOKEN.getAccessToken());

  return {
    environment: process.env.ENV,
    package_source: 'Online',
    device: window.IS_ANDROID ? 'Android' : 'iPhone',
    os_type: window.IS_ANDROID ? 'Android' : 'iOS',
    package_version: packageInfo.version,
    app_container: window.IS_IN_SKYWALKER ? 'Skywalker' : 'Playground',
    app_name: 'DANA All Biller',
    current_url: window.location.href,
    screen_height: window.innerHeight / 2,
    screen_width: window.innerWidth / 2,
    dana_public_id: token.danaPublicId,
  };
};

export const getTreatment = (client, treatment) =>
  client.getTreatmentWithConfig(treatment, createAttribute());
